export default {
  Desktop: '工作台',
  Hello: '欢迎',
  Update_notice: '功能更新公告',
  Quota: '剩余单量',
  As_of_the_date: '截止日期',
  beijing_time: '北京时间（东八区）',
  pacific_time: '太平洋时间（西7区）',
  store_authorization: '店铺授权',
  sku_archives: '货品档案',
  order_process: '订单处理',
  exam_stock_out: '验货出库',
  exam_stock_in: '验货入库',
  purchase_order: '采购单',
  warehouse_management: '仓库一览',
  collection_and_payment: '收付款管理',
  order_distribution: '日订单分布',
  Daily_order_quantity: '日订单量',
  sales_trend: '销售额趋势',
  Tips: '提示',
  sales_trend_tooltip: '货到付款的订单按下单时间纳入统计，其他订单按付款时间纳入统计。利润为预估利润',
  cross_border_ERP: '旺店通跨境ERP',
  Updates: '更新内容',
  key_function: '重点功能',
  No_more_reminder: '不再提示',
  learn_more: '更新详情',
  Got_it: '我知道了',
  seven_day: '七天',
  thirty_day: '30天',
  custom: '自定义',
  Sign_out: '退出登录',
  purchase_refund_order: '采购退货单',
  version: '版本',
  changePasswd: '修改密码',
}
